module.exports = __webpack_public_path__ + "img/search.97717458.svg";